module.exports = __webpack_public_path__ + "img/vipPropHalf.ed29b651.png";